<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <div v-if="categoriesLoading">
                <h3>Loading...</h3>
            </div>
            <div v-else class="job-history-filters">
                <base-input label="Domain name" placeholder="Domain name" v-model="filters.job__domain__name__icontains" />
                <base-input label="Category">
                    <b-dropdown variant="outline-light" :text="categories[filters.job__domain__category]">
                        <b-dropdown-item v-for="(category,index) in categories" v-bind:key="index" @click="filters.job__domain__category=index;$forceUpdate();filterTable()">{{category}}</b-dropdown-item>
                    </b-dropdown>
                </base-input>
                <base-input label="Status">
                    <b-dropdown variant="outline-light" :text="statusFilterChoices[filters.status]">
                        <b-dropdown-item v-for="(status,index) in statusFilterChoices" v-bind:key="index" @click="filters.status=index;$forceUpdate();filterTable()">{{status}}</b-dropdown-item>
                    </b-dropdown>
                </base-input>
                    <timestamp-picker field="start_time__gte" label="Start time from" @change="dateChanged" />
                    <timestamp-picker field="start_time__lte" label="Start time to" @change="dateChanged" />
                    <timestamp-picker field="end_time__gte" label="End time from" @change="dateChanged" />
                    <timestamp-picker field="end_time__lte" label="End time to" @change="dateChanged" />
            </div>
            <b-row>
                <b-col>
                    <base-button icon type="info" @click="getPage(currentPage)">
                        <span class="btn-inner--icon">
                            <b-icon icon="arrow-counterclockwise" font-scale="2"></b-icon>
                        </span>
                    </base-button>
                </b-col>
                <template v-if="jobGroupId!==undefined">
                    <b-col v-for="(statusDesc,status) in jobLogStatusDescriptions" :key="jobGroupId+'statuscount'+status">
                        <h4>{{statusDesc}}:</h4>
                        <p v-if="statusCountsLoading">Loading...</p>
                        <p v-else>{{statusCounts[status]!==undefined ? statusCounts[status] : 0}}</p>
                    </b-col>
                    <b-col>
                        <h4>Filtered total:</h4>
                        <p v-if="statusCountsLoading">Loading...</p>
                        <p v-else>{{total}}</p>
                    </b-col>
                    <b-col>
                        <h4>Total:</h4>
                        <p v-if="statusCountsLoading">Loading...</p>
                        <p v-else>{{statusCounts.total}}</p>
                    </b-col>
                </template>
            </b-row>
            
        </b-card-header>
        <div v-if="isLoading || categoriesLoading">
            <card>Loading...</card>
        </div>
        <template v-else>
            <el-table class="table-responsive table"
                    header-row-class-name="thead-light"
                    :data="jobHistories">
                <el-table-column label="ID" prop="id" />
                <el-table-column label="Domain" prop="job.domain.name" />
                <el-table-column label="Category" prop="_">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-left">
                            {{categories[row.job.domain.category]}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Status" prop="status">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{jobLogStatusDescriptions[row.status]}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Start time" prop="start_time" :formatter="formatDefaultDateTable" />
                <el-table-column label="End time" prop="end_time" :formatter="formatDefaultDateTable" />
                <el-table-column label="Time elapsed" prop="_">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{calculateElapsedTime(row.start_time,row.end_time)}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Result count" prop="result_count"/>
                <el-table-column label="Details" prop="_">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center justify-content-end">
                            <router-link v-bind:key="row.id" :to="'/job_history/'+row.id">
                                <base-button icon type="info">
                                    <span class="btn-inner--icon">
                                        <i class="ni ni-align-center"/>
                                    </span>
                                </base-button>
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="20" :total="total" @change="pageChanged">
                    <template v-slot:prev-text>
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                        </a>
                    </template>
                </base-pagination>
            </b-card-footer>
        </template>
        
    </b-card>
</template>

<script>
import {Table,TableColumn} from 'element-ui'
import TimestampPicker from '@/components/TimestampPicker.vue'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const JobHistoryRepository = RepositoryFactory.get('job_history')
const DomainCategoryRepository = RepositoryFactory.get('domain_category')

export default {
    name:'job-history-table',
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
        [TimestampPicker.name]:TimestampPicker,
    },
    props:{
        jobGroupId:Number
    },
    created(){
        for(var key in this.jobLogStatusDescriptions)
            this.statusFilterChoices[key]=this.jobLogStatusDescriptions[key]

        this.getPage(this.currentPage);
        DomainCategoryRepository.get().then((response) => {
            var categoryList = response.data;
            this.categories={null:'No category',undefined:'Not selected'}
            for(var i in categoryList){
                var category = categoryList[i]
                this.categories[category.id] = category.name;
            }
            this.categoriesLoading=false;
        })
        for(var key in this.jobLogStatusDescriptions)
            this.statusFilterChoices[key]=this.jobLogStatusDescriptions[key]
    },
    data(){
        return {
            currentPage: 1,
            total:0,
            jobHistories:null,
            lastRequestTimestamp:0,

            filters:{
                category:undefined,
            },
            filterTimer:undefined, // Filtre her inputta değil kullanıcı yazmayı bıraktığında çalışsın diye
            statusFilterChoices:{undefined:'Not selected'}, // main.js'ten gelen statüler bunun üzerine yazılacak.

            categories:null,
            categoriesLoading:true,

            isLoading:true,

            statusCounts:null,
            statusCountsLoading:true,
        }
    },
    watch:{
        filters:{
            handler(oldVal,newVal){
                clearTimeout(this.filterTimer);
                this.isLoading=true;
                for(var i in this.filters){
                    if(this.filters[i]==="")
                        delete this.filters[i]
                    }
                this.filterTimer=setTimeout(() => this.filterTable(), 1000);
            },
            deep:true,
        }
    },
    methods:{
        getPage(pageNumber){
            var timestamp=Date.now();
            this.lastRequestTimestamp=timestamp;

            this.isLoading=true;
            this.statusCountsLoading=true;

            this.currentPage=pageNumber;
            if(this.jobGroupId===undefined){
                JobHistoryRepository.getTable(pageNumber,this.filters).then((response) => {
                    if(this.lastRequestTimestamp!==timestamp) return;

                    var r=response.data;

                    this.jobHistories=r.results;
                    this.total=r.count;
                    this.currentPage=pageNumber;

                    for(var i in this.jobHistories){
                        if(this.jobHistories[i].job===null){
                            this.jobHistories[i].job={
                                domain:{
                                    name:'Malformed data',
                                    domain_address:'Malformed data',
                                }
                            }
                        }
                        if (this.jobHistories[i].start_time!==null && this.jobHistories[i].start_time!==undefined)
                            this.jobHistories[i].start_time=this.timestampToDatetime(this.jobHistories[i].start_time);
                        
                        if (this.jobHistories[i].end_time!==null && this.jobHistories[i].end_time!==undefined)
                            this.jobHistories[i].end_time=this.timestampToDatetime(this.jobHistories[i].end_time);
                    }

                    this.isLoading=false;
                })
            }
            else{
                JobHistoryRepository.getTableWithJobGroupId(this.currentPage,this.jobGroupId,this.filters).then((response) => {
                    if(this.lastRequestTimestamp!==timestamp) return;

                    var r=response.data;

                    this.jobHistories=r.results;
                    this.total=r.count;
                    this.currentPage=pageNumber;

                    for(var i in this.jobHistories){
                        if (this.jobHistories[i].start_time!==null && this.jobHistories[i].start_time!==undefined)
                            this.jobHistories[i].start_time=this.timestampToDatetime(this.jobHistories[i].start_time);
                        
                        if (this.jobHistories[i].end_time!==null && this.jobHistories[i].end_time!==undefined)
                            this.jobHistories[i].end_time=this.timestampToDatetime(this.jobHistories[i].end_time);
                    }

                    this.isLoading=false;
                })
                JobHistoryRepository.getJobGroupStatusCount(this.jobGroupId).then((response) => {
                    if(this.lastRequestTimestamp!==timestamp) return;

                    this.statusCounts=response.data;

                    var total=0;
                    for(var i in this.statusCounts){
                        total+=this.statusCounts[i]
                    }

                    this.statusCounts.total=total
                    this.statusCountsLoading=false;
                })
            }
        },
        pageChanged(pageNumber){
            this.getPage(pageNumber);
        },
        dateChanged(data){
            var filterField = data[0];
            if(data[1]===0)
                delete this.filters[filterField];
            else
                this.filters[filterField]=data[1];
            
            this.filterTable();
        },
        filterTable(){
            this.isLoading=true;
            this.getPage(1);
        }
    }
}
</script>

<style>
.job-history-filters{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap:10px;
}
</style>